<div class="title"><b>{{title}}</b> 
    <div class="new-button">
        <tv-list-actions></tv-list-actions>
    </div>
</div>